import React from 'react';
import Chart from '../chart';
import { LifePart } from '../../state/LifePart';
import { WheelBalanceData } from './wheelSnapshotUtils';

interface WheelSnapshotChartProps {
    data: WheelBalanceData[];
    emptyMessage?: string;
}

/**
 * Компонент для отображения колеса баланса из снимка
 * Использует стандартный Chart компонент с преобразованием данных
 */
export default function WheelSnapshotChart({ data, emptyMessage = 'Нет данных' }: WheelSnapshotChartProps) {
    if (data.length === 0) {
        return (
            <div className="text-center text-muted py-5">
                <p className="mb-0">{emptyMessage}</p>
            </div>
        );
    }

    // Преобразуем WheelBalanceData в LifePart для компонента Chart
    const lifeParts: LifePart[] = data.map(d => ({
        uuid: d.uuid,
        name: d.name,
        color: d.color,
        startpoint: d.startpoint,
        primary: d.primary,
        description: '',
        order: 0,
    }));

    return (
        <div style={{ maxWidth: '400px', margin: '0 auto' }}>
            <Chart 
                roles={lifeParts} 
                showLabels={false}
                maxLabelChars={20}
            />
        </div>
    );
}
